<div style="display: flex; flex-flow: row wrap; justify-content: center">
  <div style="padding: 1%" *ngFor="let soundPubEl of filteredSoundPubs">
    <app-sound-pub-item [soundPubElement]="soundPubEl"> </app-sound-pub-item>
  </div>
</div>
